import { Link } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'
import { isFirebaseConfigured } from '../lib/firebase'
import { LOCALES, useI18n, type Locale } from '../i18n'

export function AppIcon({ size = 30 }) {
  const unit = size / 30
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" aria-hidden="true">
      <rect width="30" height="30" rx={7 * unit} fill="#0e1524" stroke="rgba(255,255,255,.14)" />
      <rect x="6" y="6" width="8.5" height="8.5" rx="2" fill="#eaf2ff" />
      <rect x="16.5" y="6" width="7.5" height="7.5" rx="2" fill="#4a9eff" />
      <rect x="6" y="16.5" width="7.5" height="7.5" rx="2" fill="#4a9eff" />
      <rect x="15.5" y="15.5" width="8.5" height="8.5" rx="2" fill="#eaf2ff" />
    </svg>
  )
}

export function Check() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M3 8.5l3.2 3.2L13 5" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

/// Sélecteur natif plutôt qu'un menu maison : accessible au clavier et aux
/// lecteurs d'écran sans une ligne de code, et familier sur mobile.
function LocalePicker() {
  const { locale, setLocale } = useI18n()
  return (
    <select className="locale-picker" value={locale} aria-label="Language"
      onChange={(e) => setLocale(e.target.value as Locale)}>
      {Object.entries(LOCALES).map(([code, { label }]) => (
        <option key={code} value={code}>{label}</option>
      ))}
    </select>
  )
}

export function Nav() {
  const { user } = useAuth()
  const { t } = useI18n()
  return (
    <header className="shell">
      <nav className="nav">
        <Link to="/" className="nav-brand">
          <AppIcon />
          AppSwitch
        </Link>
        <div className="nav-links">
          <a href="/#features">{t.nav.features}</a>
          <a href="/#pricing">{t.nav.pricing}</a>
          <a href="/#faq">{t.nav.faq}</a>
          {isFirebaseConfigured && (
            <Link to="/account">{user ? t.nav.account : t.nav.signIn}</Link>
          )}
          <LocalePicker />
        </div>
      </nav>
    </header>
  )
}

export function Footer() {
  const { t } = useI18n()
  return (
    <footer className="shell footer">
      <span>© {new Date().getFullYear()} Stream Studio</span>
      <nav>
        <Link to="/terms">{t.footer.terms}</Link>
        <Link to="/privacy">{t.footer.privacy}</Link>
        <a href="https://stream.studio/">Stream Studio</a>
      </nav>
    </footer>
  )
}
